<template>
  <div class="container">
    <van-nav-bar title="成功页" left-arrow @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="success-main">
      <div class="img">
      </div>
      <h2>评价成功</h2>
      <div class="msg">{{ message }}</div>
      <div class="button-default button-primary-yellow">
        确定
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "comment",
  data() {
    return {
      message: ""
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goRouter() {
      this.$router.push({ path: "/commentSuccess" });
    }
  }
};
</script>

<style scoped lang="stylus">
@import '../../assets/stylus/mixins.styl'
.container
  min-height 100vh
  background-size cover
  bg-image($main-bg)
  .success-main
    padding 70px
    text-align center
    .img
      bg-image($commentSuccess)
    h2
      line-height 2em
    .msg
      color #828282
      font-size 14px
      line-height 2em
</style>
